jQuery(document).ready(function($){
	console.log("AppJS loaded")

	$('.js-account-sidebar-text').on('click', function() {
        $('.js-account-sidebar-text').toggleClass('is-active');
        $('.js-account-sidebar-dropdown').slideToggle(); 
        return false;
    });
  
  	$('.js-account-mobile').on('click', function() {
        $('.js-account-mobile-dropdown').slideToggle(); 
        return false;
    });

    $('.js-nav-footer h4').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).closest('div').find('ul').slideToggle(); 
        return false;
    });

    $('.js-hamburger-nav a.c-hamburgerNav__hasChild').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).closest('div').find('.c-hamburgerNav__links').slideToggle(); 
        return false;
    });

    //Drop down js start
    var closeTimeout;

    $(".js-dropdownHandler.c-nav__hasChild").hover(
    //Hover;
    function () {
        clearTimeout(closeTimeout);
        $(".js-dropdownContainer").removeClass('is-open');
        $('.o-pageContent').addClass('is-nav-open');
        $('body').addClass('is-overflow-hidden');
        $(this).find(".js-dropdownContainer").addClass('is-open');
    },
    //Hoverout;
    function () {
        closeTimeout = setTimeout(function () {
            $(".js-dropdownContainer").removeClass('is-open');
            $('.o-pageContent').removeClass('is-nav-open');
            $('body').removeClass('is-overflow-hidden');
        }, 500);
    });

    
    //Drop down js end

    $('.js-pdp-tab h3').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).closest('div').find('.c-pdpInfo__copy').slideToggle(); 
        return false;
    });

    //Scroll to section
    $(".js-scroll-to-section").on('click', function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            
            var hash = this.hash;

            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function(){
                window.location.hash = hash;
            });
        }
    });

    $('.js-product-slide').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: false,
        adaptiveHeight: true
    });


    $('.js-show-ingredients').on('click', function() {
        $(this).hide();
        $('.c-pdpInfo__shortIngredients').hide();
        $('.c-pdpInfo__fullIngredients').slideDown(); 
        return false;
    }); 

    $('.js-filter-tabs .c-collectionFilter__heading').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).closest('div').find('.c-collectionFilter__checkbox').slideToggle(); 
        return false;
    }); 

    // Home page slick slider

    $('.js-noteworthy-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '60px'
                }
            }
        ]
    });

    $('.js-brand-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '60px'
                }
            }
        ]
    });

    $('.js-testimonial-slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: true,
        adaptiveHeight: true
    });

});

var cartDrawer = jQuery(".js-cartCanvas").offcanvas({
	showOverlay: true
});

var cartDrawerMenu = jQuery(".js-cartCanvasMenu").offcanvas({
    showOverlay: true
});
